import PropTypes from 'prop-types';
import React from 'react';
import { Provider as CommunityProvider } from '../../../../../contexts/CommunityContext';
import ArrowPagination from '../../../../Elements/ArrowPagination/ArrowPagination';
import Button from '../../../../Input/Button/Button';

import './GroupSearchResults.scss';
import ResultGroup from './ResultGroup/ResultGroup';

export class GroupSearchResults extends React.PureComponent {
    static propTypes = {
        /**
         * search results of groups
         */
        groupResults: PropTypes.array,
        /**
         * starting number of current paginations
         */
        startNum: PropTypes.number.isRequired,
        /**
         * ending number of current paginations
         */
        endNum: PropTypes.number.isRequired,
        /**
         * total number of results
         */
        total: PropTypes.number.isRequired,
        /**
         * false if all search fields are empty; otherwise, true
         */
        isSearchActive: PropTypes.bool.isRequired,
        /**
         * handler for previous page pagination
         */
        goToPrevPage: PropTypes.func,
        /**
         * handler for next page pagination
         */
        goToNextPage: PropTypes.func,
        /**
         * whether results is paginated or not
         */
        showAllResults: PropTypes.bool.isRequired,
        /**
         * whether window view width is checked or not, it determines how the results will paginated
         */
        isViewWidthChecked: PropTypes.bool.isRequired,
        /**
         * whether the search is in loading state
         */
        isSearchLoading: PropTypes.bool.isRequired,
        /**
         * number of results per page
         */
        resultsPerPage: PropTypes.number.isRequired,
    };

    static defaultProps = {
        groupResults: [],
        startNum: 0,
        endNum: 0,
        total: 0,
        isSearchActive: false,
        goToPrevPage: () => null,
        goToNextPage: () => null,
        showAllResults: false,
        isViewWidthChecked: false,
        isSearchLoading: false,
        resultsPerPage: 6,
    };

    getFadeInDelayTime = (index, resultsPerPage) => {
        let fadeInDelay = 0;

        if (index > 0) {
            if (index % (resultsPerPage - 1) === 0) {
                fadeInDelay = index * 300;
            }
            fadeInDelay = (index % resultsPerPage) * 300;
        }

        return fadeInDelay;
    };

    render() {
        const {
            groupResults,
            total,
            startNum,
            endNum,
            goToPrevPage,
            goToNextPage,
            showAllResults,
            isViewWidthChecked,
            isSearchActive,
            isSearchLoading,
            resultsPerPage,
        } = this.props;

        const numberRange =
            startNum && endNum ? `${startNum} - ${endNum}` : '0 - 0';
        const hasMorePages = Number(endNum) < Number(total);
        const noResults = groupResults && groupResults.length < 1;

        if (!isSearchActive || !isViewWidthChecked) {
            return null;
        }

        if (noResults && !isSearchLoading) {
            return (
                <div className="component-Groups-GroupSearchResults fade-in-animation">
                    <div className="no-result-msg">
                        0 results. Try broadening your search for more results.
                    </div>
                </div>
            );
        }

        if (showAllResults) {
            return (
                <div className="component-Groups-GroupSearchResults">
                    <div className="results-wrapper">
                        {groupResults &&
                            groupResults.map((group, index) => (
                                <ResultGroup
                                    key={`group-result-${index}`}
                                    index={index}
                                    waitTime={this.getFadeInDelayTime(
                                        index,
                                        resultsPerPage
                                    )}
                                    group={group}
                                />
                            ))}
                    </div>
                    <div className="pagination-wrapper">
                        {hasMorePages && (
                            <Button
                                type="solid"
                                value="Load more results"
                                className="load-more-btn"
                                inputStyle="load-more-input"
                                onClick={goToNextPage()}
                            />
                        )}
                    </div>
                </div>
            );
        }

        return (
            <div className="component-Groups-GroupSearchResults">
                <div className="results-wrapper">
                    {groupResults &&
                        groupResults.map((group, index) => (
                            <ResultGroup
                                key={`group-result-${index}`}
                                index={index}
                                waitTime={this.getFadeInDelayTime(
                                    index,
                                    resultsPerPage
                                )}
                                group={group}
                            />
                        ))}
                </div>
                <div className="pagination-wrapper">
                    <ArrowPagination
                        numberRange={numberRange}
                        total={total}
                        prevPage={goToPrevPage()}
                        nextPage={goToNextPage()}
                        hideArrowIfNoPagination={true}
                    />
                </div>
            </div>
        );
    }
}

export default (props) => (
    <CommunityProvider content={[]}>
        <GroupSearchResults {...props} />
    </CommunityProvider>
);
